import type { ZodEnum, ZodNullable } from 'zod';

export function getEnumValues<E extends string>(
  enumSchema: ZodEnum<[E, ...E[]]> | ZodNullable<ZodEnum<[E, ...E[]]>>,
): E[] {
  const isNullable = (
    schema: any,
  ): schema is ZodNullable<ZodEnum<[E, ...E[]]>> =>
    schema._def.typeName === 'ZodNullable';

  if (isNullable(enumSchema)) {
    return enumSchema._def.innerType.options;
  } else {
    return enumSchema.options;
  }
}
